import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmployeeManagementComponent } from './employee-management/employee-management.component';
import { ClockInOutComponent } from './clock-in-out/clock-in-out.component';
import { AttendanceReportComponent } from './attendance-report/attendance-report.component';
import { SalaryManagementComponent } from './salary-management/salary-management.component';
import { Layouts } from '../app.component'
import { AttendanceImportComponent } from './attendance-import/attendance-import.component';
import { AttendanceIndividualPunchImportComponent } from './attendance-individual-punch-import/attendance-individual-punch-import.component';
import { MonthlyAttendanceReportComponent } from './monthly-attendance-report/monthly-attendance-report.component';
import { ManualAttendanceEntryComponent } from './manual-attendance-entry/manual-attendance-entry.component';
import { SalaryPaymentDialogComponent } from './salary-management/salary-payment-dialog.component';
import { AttendanceDashboardComponent } from './attendance-dashboard/attendance-dashboard.component';
import { AttendanceMainDashboardComponent } from './attendance-main-dashboard/attendance-main-dashboard.component';
import { AttendanceAdminGuard } from '../guards/attendance-admin.guard';
import { AttendanceManagerGuard } from '../guards/attendance-manager.guard';
import { DeviceManagementComponent } from './device-management/device-management.component';

const routes: Routes = [
      {
        path: 'attendance',
        component: AttendanceMainDashboardComponent,
        data: { layout: Layouts.Main }
      },
      {
        path: 'attendance/main',
        component: AttendanceMainDashboardComponent,
        data: { layout: Layouts.Main }
      },
      {
        path: 'attendance/dashboard',
        component: AttendanceDashboardComponent,
        data: { layout: Layouts.Main }
      },
      {
        path: 'attendance/employees',
        component: EmployeeManagementComponent,
        data: { layout: Layouts.Main },
        canActivate: [AttendanceManagerGuard]
      },
      {
        path: 'attendance/clock-in-out',
        component: ClockInOutComponent,
        data: { layout: Layouts.Main }
      },
      {
        path: 'attendance/reports',
        component: AttendanceReportComponent,
        data: { layout: Layouts.Main },
        canActivate: [AttendanceAdminGuard]
      },
      {
        path: 'attendance/salary',
        component: SalaryManagementComponent,
        data: { layout: Layouts.Main },
        canActivate: [AttendanceAdminGuard]
      },
      {
        path: 'attendance/import',
        component: AttendanceImportComponent,
        data: { layout: Layouts.Main },
        canActivate: [AttendanceAdminGuard]
      },
      {
        path: 'attendance/import-individual-punches',
        component: AttendanceIndividualPunchImportComponent,
        data: { layout: Layouts.Main },
        canActivate: [AttendanceManagerGuard]
      },
  {
    path: 'attendance/monthly-report',
    component: MonthlyAttendanceReportComponent,
    data: { layout: Layouts.Main },
    canActivate: [AttendanceManagerGuard]
  },
  {
    path: 'attendance/manual-entry',
    component: ManualAttendanceEntryComponent,
    data: { layout: Layouts.Main },
    canActivate: [AttendanceManagerGuard]
  },
      {
        path: 'attendance/devices',
        component: DeviceManagementComponent,
        data: { layout: Layouts.Main },
        canActivate: [AttendanceAdminGuard]
      },
  //{ path: 'employees', component: EmployeeManagementComponent },
  //{ path: 'clock-in-out', component: ClockInOutComponent },
  //{ path: 'reports', component: AttendanceReportComponent },
  //{ path: 'salary', component: SalaryManagementComponent },
  //{ path: '', redirectTo: 'employees', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttendanceRoutingModule { }